import axiosInstance from 'api/axiosInstance';
import { URL_CANTRACK_READ_CUSTOMER } from 'constants/urls';

const getCustomer = async (id: number) => {
  try {
    const { data } = await axiosInstance.get(
      `${URL_CANTRACK_READ_CUSTOMER}?id=${id}`,
    );
    return data;
  } catch (error) {
    console.error('[getCustomer] Failed:', error);
    throw error;
  }
};

export default getCustomer;
